import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import TermsModal from './TermsModal';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';


const Terms = () => {
    
    const [searchQuery, setSearchQuery] = useState('');
    const [pincodes, setPincodes] = useState([]);
    const [filteredPincodes, setFilteredPincodes] = useState(pincodes);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAttribute, setSelectedAttribute] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [categories, setCategories] = useState([])
    const { id } = useParams();
    const user = getDecryptedUserFromCookie();
    const url = API_BASE_URL
    const [data, setData] = useState({
        name: "",
        slug: "",
        attributeId: id,
        user_id: user.main_id,
        user_name: user.full_name
    })
    const [load, setLoad] = useState(false);
    const token = decryptToken("accessToken") || ""



    // Effect to handle filtering
    useEffect(() => {
        const filtered = pincodes.filter((pincode) =>
            Object.values(pincode).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredPincodes(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, pincodes]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredPincodes.length / itemsPerPage);
    const currentData = filteredPincodes.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const fetchData = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/terms/${id}`)
            const res = await response.json();
            ;
            setPincodes(res);
        } catch (error) {
            console.error(error)
        } finally {
            setLoad(false);
        }
    }

    const toggleStatus = async (index) => {
        try {
            const attribute = currentData[index];
            const newStatus = attribute.status === "Active" ? "Inactive" : "Active";

            const response = await fetch(`${url}/terms/toggle/${attribute.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ status: newStatus })
            });

            if (response.ok) {
                const updatedAttribute = { ...attribute, status: newStatus };
                const updatedPincodes = [...pincodes];
                const originalIndex = pincodes.findIndex((item) => item.id === attribute.id);
                updatedPincodes[originalIndex] = updatedAttribute;
                setPincodes(updatedPincodes);
                toast.success(`Status updated to ${newStatus}`, {
                    position: "top-center",
                    autoClose: 2000
                })
                // console.log(`Status updated to ${newStatus}`);
            } else {
                console.error("Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    let handleDelete = async (delid) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this item",
                icon: "error",
                showCancelButton: true,
                backdrop: `rgba(60,60,60,0.8)`,
                confirmButtonText: "Yes, delete it!",
                confirmButtonColor: "#c03221",
            });

            if (result.isConfirmed) {
                let response = await fetch(`${url}/terms/${delid}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                         Authorization: `Bearer ${token}`,
                    }
                });

                if (response.ok) {
                    await Swal.fire("Deleted!", "Your item has been deleted.", "success");
                    let res = await response.json();
                    ;
                    const updatedList = pincodes.filter((item) => item.id !== delid);
                    setPincodes(updatedList);
                } else {
                    let res = await response.json();
                    ;
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/unit/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            ;
            setCategories(res.data.reverse());
        } catch (error) {
            console.error(error)
        }
    }



    useEffect(() => {
        fetchData();
        fetchCategories();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }

    return (
        <>
           
         
                <div className="oms-header">
                    <h1 className="dashboard-title">Terms</h1>

                    {/* Add Offers Button */}
                    <button
                        className="oms-add-btn"
                        onClick={() => {
                            setSelectedAttribute(null);
                            setIsEdit(false);
                            setIsModalOpen(true);
                        }}
                    >
                        Add Terms
                    </button>

                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img src={`${customer.image}`} style={{width:"50px",height:"50px",borderRadius:"50%"}} alt="" />
                                        </td>
                                        <td>{customer.name ||"N/A"}</td>
                                        <td>{customer.slug ||"N/A"}</td>
                                        <td>
                                            <button
                                                className={`status-toggle ${customer.status ? 'Active' : 'Inactive'}`}
                                                onClick={() => toggleStatus(index)}
                                            >
                                                {customer.status === "Active" ? (
                                                    <i className="fas fa-toggle-on"></i> // Active
                                                ) : (
                                                    <i className="fas fa-toggle-off"></i> // Inactive
                                                )}
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setSelectedAttribute(customer);
                                                    setIsEdit(true);
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(customer.id)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No Terms found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
         

            <TermsModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                fetchData={fetchData}
                selectedAttribute={selectedAttribute}
                isEdit={isEdit}
                attributeId={id}
                categories={categories}
            />

        </>
    );
};

export default Terms;
